import styled from 'styled-components';

import C from '@assets/themes/colors';
interface IRootProps {
  active?: boolean;
}
export const Root = styled.div`
  font-family: Roboto;
  margin-top: 6px;
  margin-left: 5px;
`;

export const ButtonContainer = styled.div`
  font-size: 12px;
  font-weight: bold;
  color: ${C.WHITE};
  display:flex;
  width: 36px;
  height: 31px;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
      background-color: ${(props: IRootProps) => (props.active ? C.GRAY : '')};
      cursor: ${(props: IRootProps) => (props.active ? 'pointer' : 'default')};
  }
`;